var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-editor',{staticClass:"html-editor",attrs:{"value":_vm.value,"editor-toolbar":_vm.customToolbar},on:{"input":(event) => _vm.$emit('input', event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }